import "../css/app.scss";
import barba from "@barba/core";
// import barbaPrefetch from "@barba/prefetch";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

/** Pages */
import Home from "./pages/home";
import Standard from "./pages/standard";
import News from "./pages/news";
import Location from "./pages/location";

/** Global Components */
import Header from "./components/header";
import Hamburger from "./components/hamburger";
import Footer from "./components/footer";
// import Newsletter from './components/newsletter';

$(() => {
  // init global components
  window._gsap = gsap;
  window._ScrollTrigger = ScrollTrigger;
  window._gsap.registerPlugin(ScrollTrigger);

  window._header = new Header($('[data-header="el"]'));
  window._hamburger = new Hamburger($('[data-hamburger="el"]'));
  window._$html = $("html");

  window._footer = new Footer($('[data-footer="el"]'));

  window._newsLetterModal = $("#newsletterModal");

  // new Newsletter($('[data-newsletter="el"]'));

  // barba.use(barbaPrefetch);

  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }

  // init barba
  barba.init({
    timeout: 30000,
    views: [Home, Standard, News, Location],
    prevent: ({ el }) => {
      return (
        el.href.startsWith("#") ||
        el.href === window.location.href ||
        (el.id && el.id.startsWith("m"))
      );
    },
  });

  // set footer links
  const $translateLinks = $('[data-translate="link"]');

  $translateLinks.each((i, el) => {
    const $el = $(el);
    $el.attr("href", $el.data("href"));
  });
});
